import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var SearchResult = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchResult, _React$Component);

  var _super = _createSuper(SearchResult);

  function SearchResult() {
    _classCallCheck(this, SearchResult);

    return _super.apply(this, arguments);
  }

  _createClass(SearchResult, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          selected = _this$props.selected,
          props = _objectWithoutProperties(_this$props, ["children", "className", "selected"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames('cloud-ui-search-result', className, {
          selected: selected
        })
      }, props), children);
    }
  }]);

  return SearchResult;
}(React.Component);

_defineProperty(SearchResult, "propTypes", {
  className: PropTypes.string,
  name: PropTypes.string,
  phrase: PropTypes.string,
  selected: PropTypes.bool
});

export default SearchResult;